import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./ContactModal.css";

function ContactModal({ show, handleClose }) {
  // --- Form state ---
  const [formData, setFormData] = useState({
    name: "",
    whatsapp: "",
    email: "",
    network: "",
    plan: "",
  });
  const [status, setStatus] = useState("");

  // --- Handle input changes ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- Validate form ---
  const validateForm = () => {
    const { name, whatsapp, email, network, plan } = formData;
    if (!name || !whatsapp || !email || !network || !plan) {
      setStatus("⚠️ Please fill in all fields.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus("❌ Please enter a valid email address.");
      return false;
    }
    return true;
  };

  // --- Handle form submit ---
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const { name, whatsapp, email, network, plan } = formData;
    const message = `Hello, I'd like to get in touch!\n\n*Name:* ${name}\n*Mobile:* ${whatsapp}\n*Email:* ${email}\n*Network:* ${network}\n*Plan:* ${plan}`;
    const encodedMessage = encodeURIComponent(message);
    
    // User requested WhatsApp number: 0781171177
    const whatsappNumber = "94781171177"; 

    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
    
    setFormData({
      name: "",
      whatsapp: "",
      email: "",
      network: "",
      plan: "",
    });
    setStatus("");
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdropClassName="modal-backdrop-custom"
      contentClassName="modal-content-custom"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="modal-title-custom">Get in Touch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="input-custom"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formWhatsapp">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              type="text"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleChange}
              required
              className="input-custom"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input-custom"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formNetwork">
            <Form.Label>Network</Form.Label>
            <Form.Select
              name="network"
              value={formData.network}
              onChange={handleChange}
              required
              className="input-custom"
            >
              <option className="input-option" value="">Select Network</option>
              <option className="input-option" value="Dialog">Dialog</option>
              <option className="input-option" value="Mobitel">Mobitel</option>
              <option className="input-option" value="Hutch">Hutch</option>
              <option className="input-option" value="Airtel">Airtel</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPlan">
            <Form.Label>Plan</Form.Label>
            <Form.Select
              name="plan"
              value={formData.plan}
              onChange={handleChange}
              required
              className="input-custom"
            >
              <option className="input-option" value="">Select Plan</option>
              <option className="input-option" value="Bronze (Below 10,000 LKR)">Bronze (Below 10,000 LKR)</option>
              <option className="input-option" value="Silver (10,000 - 25,000 LKR)">Silver (10,000 - 25,000 LKR)</option>
              <option className="input-option" value="Gold (25,000 - 50,000 LKR)">Gold (25,000 - 50,000 LKR)</option>
              <option className="input-option" value="Platinum (50,000 - 100,000 LKR)">Platinum (50,000 - 100,000 LKR)</option>
              <option className="input-option" value="VIP (Above 100,000 LKR)">VIP (Above 100,000 LKR)</option>
            </Form.Select>
          </Form.Group>

          <Button
            type="submit"
            className="w-100 submit-btn"
          >
            Send Message
          </Button>
        </Form>

        {status && <p className="mt-3">{status}</p>}
      </Modal.Body>
    </Modal>
  );
}

export default ContactModal;
